<cv-header class="print:hidden"></cv-header>
<div class="bg-primary-10 height-layout print:pt-0">
  <ng-content></ng-content>
</div>
